import { render, staticRenderFns } from "./Enderecos.vue?vue&type=template&id=ada6cf3a"
import script from "./Enderecos.vue?vue&type=script&lang=js"
export * from "./Enderecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports